"use strict";
import introJs from "intro.js";
const {
  storeTourPathDB,
  storePathToLocalStorage,
  isTourPathCached
} = require("../hooks/useStoreTourPaths");
const useIntroJs = (currentTourSteps, isUserLoggedIn, path) => {
  return introJs().onComplete(() => {
    if (isUserLoggedIn && !isTourPathCached(path)) {
      storeTourPathDB(path);
      storePathToLocalStorage(path);
    }
  }).onExit(() => {
    if (isUserLoggedIn && !isTourPathCached(path)) {
      storeTourPathDB(path);
      storePathToLocalStorage(path);
    }
  }).setOptions({
    steps: currentTourSteps
  }).start();
};
export { useIntroJs };
